import appendQuery from 'append-query';
import urlJoin from 'url-join';
import Cookie from 'js-cookie';
import Vue from 'vue';

export function defaultListSegments(given) {
  return given && given.length ? given : ['all'];
}

export function defaultListColumns() {
  return ['Customer ID', 'Customer Name', 'Gender', 'Age', 'Email Address'];
}

export const CUSTOMERS_FILE_TYPE = 'customers';

export const BASE_URL =
  process.env.NODE_ENV === 'development' ?
  'http://127.0.0.1:5000' : 'https://score-api.superfluid.io';
    // 'https://test.superscore.me' : 'https://test.superscore.me';

    // 'http://62.171.180.223:5000' : 'https://rensource-api.superscore.me';

export const doNothing = () => {};

export const fullURL = (endpoint, params = {}) => {
  return appendQuery(urlJoin(BASE_URL, endpoint), params);
};

export const parseAxiosError = e => {
  return Error(e.message);
};

export const hasAllRequiredEntities = (entities, entityMap) => {
  return entities.every(({required, name}) => {
    return !required || (entityMap.hasOwnProperty(name) && !!entityMap[name]);
  });
};

export const JWT_TOKEN_KEY = "_ss_at_";

export function setCookie(key, value) {
  const parser = document.createElement('a');
  parser.href = window.location;
  const domain = parser.hostname.replace("app.", "");
  Cookie.set(
    key,
    value,
    {domain, expires: 365}
  );
}

export function getCookie(key) {
  return Cookie.get(key);
}

export function setToken(token) {
  setCookie(JWT_TOKEN_KEY, token);
}

export function getToken() {
  return Cookie.get(JWT_TOKEN_KEY);
}

export function removeCookie(){
  const parser = document.createElement('a');

  parser.href = window.location;
  const domain = parser.hostname.replace("app.", "");
  console.log("Removing cookie....")
  return Cookie.remove(JWT_TOKEN_KEY, {domain: domain});
}

export const E_DOWNLOAD = "DOWNLOAD";
export const eventHub = new Vue();
